export type Sorting<T> = {
  id: T extends string ? T : keyof T;
  desc: boolean;
};

export interface PaginationOptions<T> {
  limit: number;
  offset: number;
  sorting: Sorting<T>;
}

export interface RequestOptions<T> {
  query?: {
    column: T extends string ? T : keyof T;
    value: string;
  } | null;
  pagination?: PaginationOptions<T>;
}

export const defaultRequestOptions = {
  query: null,
  pagination: {
    limit: 10,
    offset: 0,
    sorting: { id: 'updated_at', desc: true },
  },
} as const satisfies RequestOptions<string>;
